import { formatDate, formatDayMonth } from './formatDate';
// Date helpers for the attendance screens. Every date here is a local calendar date as YYYY-MM-DD.
// Never use toISOString().split('T')[0] for these: it gives the UTC date, which is the wrong day
// between midnight and 5 am in Pakistan.

const pad = (n) => String(n).padStart(2, '0');

export const localISO = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const todayISO = () => localISO(new Date());

export function parseISO(iso) {
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function isValidISO(iso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(iso || ''))) return false;
  return localISO(parseISO(iso)) === iso;
}

export function shiftISO(iso, days) {
  const d = parseISO(iso);
  d.setDate(d.getDate() + days);
  return localISO(d);
}

// 1 January of the current year: used when the session start is missing or unusable.
export const fallbackStartISO = () => `${new Date().getFullYear()}-01-01`;

// Start date of the current academic session, from the rows db.getAcademicYears returns.
export function sessionStartISO(rows) {
  const cur = (rows || []).find(y => y.is_current);
  const raw = String(cur?.start_date || '').slice(0, 10);
  return isValidISO(raw) && raw <= todayISO() ? raw : fallbackStartISO();
}

// A student counts on a past date only when they have an admission date on or before it.
export function admittedBy(student, iso) {
  const a = String(student?.admissionDate || '').slice(0, 10);
  return !!a && a <= iso;
}

export function longDate(iso, withYear = false) {
  const wd = parseISO(iso).toLocaleDateString('en-PK', { weekday: 'long' });
  return `${wd}, ${withYear ? formatDate(iso) : formatDayMonth(iso)}`;
}
